import { useEffect, useState } from 'react';
import { Sparkles, X } from 'lucide-react';

// Sitewide launch-offer countdown ribbon.
// Target is set to end-of-current-month by default so it always looks live.
function getTarget() {
  const stored = localStorage.getItem('cnm_offer_ends_at');
  if (stored) {
    const t = Number(stored);
    if (!Number.isNaN(t) && t > Date.now()) return t;
  }
  const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59); // last day this month
  const t = end.getTime();
  localStorage.setItem('cnm_offer_ends_at', String(t));
  return t;
}

function fmt(ms) {
  if (ms <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  const s = Math.floor(ms / 1000);
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

export default function CountdownRibbon() {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('cnm_ribbon_dismissed') === '1');
  const [target] = useState(getTarget);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (dismissed) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [dismissed]);

  if (dismissed) return null;
  const t = fmt(target - now);

  const dismiss = () => {
    sessionStorage.setItem('cnm_ribbon_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="w-full text-white text-xs md:text-sm" style={{background: 'linear-gradient(90deg, #F59E0B 0%, #EA580C 50%, #DC2626 100%)'}} data-testid="countdown-ribbon">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 md:gap-3 flex-wrap">
          <span className="inline-flex items-center gap-1.5 font-bold"><Sparkles size={14} /> 50% Startup Offer</span>
          <span className="hidden md:inline text-white/80">ends in</span>
          <div className="flex items-center gap-1.5 font-mono font-bold" data-testid="countdown-timer">
            <TimeBox v={t.d} l="d" />
            <span>:</span>
            <TimeBox v={t.h} l="h" />
            <span>:</span>
            <TimeBox v={t.m} l="m" />
            <span>:</span>
            <TimeBox v={t.s} l="s" />
          </div>
          <a href="/shop" className="ml-1 underline underline-offset-2 font-semibold hover:text-white/90" data-testid="countdown-shop-link">Grab yours →</a>
        </div>
        <button onClick={dismiss} aria-label="Dismiss" className="p-1 rounded-full hover:bg-white/15 shrink-0" data-testid="countdown-close-btn">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}

function TimeBox({ v, l }) {
  const s = String(v).padStart(2, '0');
  return <span className="inline-flex flex-col items-center leading-none"><span>{s}</span><span className="text-[8px] font-normal text-white/70 md:hidden">{l}</span></span>;
}
